import React, { useEffect, useRef, useState } from 'react'
import ItemsApp, { EmptyItemModel, IInventoryModel, IItemModel } from './ItemsApp'
import GenerateIcon from '../../components/GenerateIcon'
import QuickItemViewBox from '../../components/DataDisplayer/QuickItemViewBox'
import { useReturnAllItems } from './itemsSlice'
import LocationsApp, { ILocationModel } from '../locations/LocationsApp'
import SectionsApp, { ISectionModel } from '../sections/SectionsApp'
import WarehousesApp, { IWarehouseModel } from '../warehouses/WarehousesApp'
import { IAxiosDefaultDataObject } from '../../config'
import BaseApp from '../BaseApp'
import { useReturnAllLocations } from '../locations/locationsSlice'
import { useReturnAllWarehouses } from '../warehouses/warehousesSlice'
import { useReturnAllSections } from '../sections/sectionsSlice'
import { Skeleton } from '@mui/material'
import { useReturnAllUsers, useReturnCurrentUser } from '../user/userSlice'
import UsersApp from '../user/UsersApp'
import ReturnItemToOriginButton from './ReturnItemToOriginButton'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import BasicModalWindow from '../../components/BasicModalWIndow'
import ItemInventory from './ItemInventory'

interface IProps {
    item: IItemModel,
    returnToOrigin?: boolean,
}

export interface IItemLocation {
    type: "location" | "section" | "warehouse" | "user",
    label: string,
    id: number
}

interface ISingleCurrentItemLocationProps {
    location: IItemLocation,
    addArrow: boolean
}
export const SingleCurrentItemLocation = (props: ISingleCurrentItemLocationProps) => {

    const { location, addArrow } = props
    const [showQuickViewBox, setShowQuickViewBox] = useState<boolean>(false)

    let quickViewItemId: number = location.id
    let quickViewBaseApp = new BaseApp()

    const allLocations = useReturnAllLocations()
    const allWarehouses = useReturnAllWarehouses()
    const allSections = useReturnAllSections()
    const allUsers = useReturnAllUsers()

    const currentUser = useReturnCurrentUser()

    const list = () => {
        switch(location.type){

            case "location":
                return allLocations

            case "section":
                return allSections

            case "user":
                return allUsers

            default:
                return allWarehouses
        }
    }

    if (location.type === "warehouse"){
        quickViewBaseApp = new WarehousesApp()
    }

    if (location.type === "section"){
        quickViewBaseApp = new SectionsApp()
    }

    if (location.type === "location"){
        quickViewBaseApp = new LocationsApp()
    }

    if (location.type === "user"){
        quickViewBaseApp = new UsersApp()
    }

    const returnLabel = () => {

        if (location.type === "user"){
            return "With " + location.label
        }

        return location.label
    }

    const renderQuickViewBox = () => {

        if (location.type === "user"){
            if (!currentUser.is_superuser){
                return <></>
            }
        }

        return <QuickItemViewBox shown={showQuickViewBox} handleHide={() => setShowQuickViewBox(false)} itemsList={list} itemId={quickViewItemId} baseApp={quickViewBaseApp} />
    }

    return(
        <>
            <div className="item-single-current-location" onClick={() => setShowQuickViewBox(true)}>
                <div className="content-of-item-single-current-location">
                    <h4>{returnLabel()}</h4>
                    {location.id !== 0 && renderQuickViewBox()}
                </div>
            </div>
            {addArrow && <GenerateIcon icon="arrow-right" />}
        </>
    )
}

export default function CurrentItemLocation(props: IProps) {

    const { item } = props

    const [modalOpen, setModalOpen] = useState<boolean>(false)


    if (!item.inventory_details){
        return <p>-</p>
    }

    const { warehouse, warehouse_id, section, section_id, location_id, location, user, user_id } = item.inventory_details
    const inventory_count = item.inventory_count ? item.inventory_count : 0

    const renderWarehouse = () => {
        return(
            <>
                <div className="item-single-current-location">
                    <div className="content-of-item-single-current-location">
                        <h4>{warehouse}</h4>
                    </div>
                </div>
                <GenerateIcon icon="arrow-right" />
                <div className="item-single-current-location">
                    <div className="content-of-item-single-current-location">
                        <h4>{section}</h4>
                    </div>
                </div>
            </>
        )
    }

    const renderLocation = () => {
        return(
            <div className="item-single-current-location">
                <div className="content-of-item-single-current-location">
                    <h4>{location}</h4>
                </div>
            </div>
        )
    }

    const renderUser = () => {
        return(
            <div className="item-single-current-location">
                <div className="content-of-item-single-current-location">
                    <h4>{user}</h4>
                </div>
            </div>
        )
    }


    const renderContent = () => {

        if (warehouse){
            return renderWarehouse()
        }

        if (location){
            return renderLocation()
        }

        if (user){
            return renderUser()
        }

        return <></>
    }

    return(
        <div className="item-current-location">
            {/* <BasicModalWindow
                shown={modalOpen}
                handleClose={() => setModalOpen(false)}
                showHeader
                title="Where item is now"
                size="lg"
                actionButtons={[]}
            >
                {modalOpen && <ItemInventory itemUniqueId={item.unique_id} disableActionButtons displayOnlyRecords />}
            </BasicModalWindow> */}
            <div className="content-of-item-current-location">
                {renderContent()}
            </div>

            {/* {inventory_count > 1 && <p className="show-all-locations" onClick={() => setModalOpen(true)}>Show all locations</p>} */}
            {inventory_count > 1 && <p className="show-all-locations">More then one location</p>}

        </div>
    )
}

function CurrentItemLocation2(props: IProps) {

    const dispatch = useDispatch()

    const { returnToOrigin } = props

    const itemsApp = new ItemsApp()

    const [item, setItem] = useState<IItemModel>(EmptyItemModel)
    const [loading, setLoading] = useState<boolean>(true)

    const [locations, setLocations] = useState<IItemLocation[]>([])

    const [modalOpen, setModalOpen] = useState<boolean>(false)

    const hasLoadedItem = useRef(false)

    const loadedItemIds = useRef<Set<string>>(new Set())

    const [loadedItem, setLoadedItem] = useState<number>()

    /**
     * Load first record
     */
    const loadFirstRecord = (unique_id: string) => {

        setLoading(true)

        itemsApp.itemInventory(unique_id, true)
            .then(response => {
              
                const record: IInventoryModel = response.data[0]
                const { warehouse, section, location, user, warehouse_id, section_id, location_id, user_id } = record

                let locationsList: IItemLocation[] = []

                if (warehouse){
                    locationsList = [
                        {
                            id: warehouse_id,
                            type: "warehouse",
                            label: warehouse
                        },
                        {
                            id: section_id,
                            type: "section",
                            label: section
                        }
                    ]
                }

                if (location){
                    locationsList = [
                        {
                            id: location_id,
                            type: "location",
                            label: location
                        }
                    ]
                }

                if (user_id){
                    locationsList = [
                        {
                            id: user_id,
                            type: "user",
                            label: user
                        }
                    ]
                }

                setLocations(locationsList)
                setLoading(false)
                
            })
            .catch(error => {
                handleRequestError(error, dispatch)
                setLoading(false)
            })
    }

    /**
     * Update item
     */
    useEffect(() => {
        if (!loadedItem){
            setItem(props.item)
            setLoadedItem(props.item.id)
            loadFirstRecord(props.item.unique_id)
        }
    }, [props.item])

    /**
     * Load record
     */
    useEffect(() => {
        if (item.unique_id){
            loadFirstRecord(item.unique_id)
        }
    }, [item])

    // useEffect(() => {
    //     if (props.item.unique_id){
    //         setItem(props.item)
    //         setLoadedItem(props.item.id)
    //         loadFirstRecord(props.item.unique_id)
    //     }
    // }, [])


    return(
        <div className="item-current-location">
        
            <BasicModalWindow
                shown={modalOpen}
                handleClose={() => setModalOpen(false)}
                showHeader
                title="Where item is now"
                size="lg"
                actionButtons={[]}
            >
                {modalOpen && <ItemInventory itemUniqueId={item.unique_id} disableActionButtons displayOnlyRecords />}
            </BasicModalWindow>
            <div className="content-of-item-current-location">
                {loading ? <div style={{ display: "flex", gap: 5 }}><Skeleton variant="text" width={100} /><Skeleton variant="text" width={100} /></div> : locations.map((location, index) => <SingleCurrentItemLocation location={location} key={index} addArrow={locations.length !== (index + 1)} />)}
            </div>
            {/* {item.inventory_count > 1 && <p className="show-all-locations" onClick={() => setModalOpen(true)}>Show all locations</p>} */}
            {/* {returnToOrigin && <div className="return-to-origin-of-item-current-location"><ReturnItemToOriginButton item={item}  /></div>} */}
        </div>
    )
}

export function OldCurrentItemLocation(props: IProps) {

    const { returnToOrigin } = props

    const [item, setItem] = useState<IItemModel>(EmptyItemModel)
    const [loading, setLoading] = useState<boolean>(true)

    const status = item.status
    const location_id = item.location_id
    const { user_full_name, user_id } = item

    const [locations, setLocations] = useState<Array<IItemLocation>>([])

    useEffect(() => {
        setItem(props.item)
    }, [props.item])

    useEffect(() => {

        if (location_id){
            setLocations([
                {
                    type: "location",
                    label: item.location_title,
                    id: item.location_id
                }
            ])
        }else{
            setLocations([
                {
                    type: "warehouse",
                    label: item.warehouse_title,
                    id: item.warehouse_id
                },
                {
                    type: "section",
                    label: item.section_title,
                    id: item.section_id
                }
            ])
        }

        if (user_id){
            setLocations([
                {
                    type: "user",
                    label: user_full_name,
                    id: user_id
                }
            ])
        }

        if (item.id){
            setLoading(false)
        }

    }, [item])

    return(
        <div className="item-current-location">
            <div className="content-of-item-current-location">
                {loading ? <div style={{ display: "flex", gap: 5 }}><Skeleton variant="text" width={100} /><Skeleton variant="text" width={100} /></div> : locations.map((location, index) => <SingleCurrentItemLocation location={location} key={index} addArrow={locations.length !== (index + 1)} />)}
            </div>
            {returnToOrigin && <div className="return-to-origin-of-item-current-location"><ReturnItemToOriginButton item={item}  /></div>}
        </div>
    )
}